import React, { forwardRef } from "react";
import { useReactToPrint } from "react-to-print";
import { StatementReport } from "./StatementReport";
import { InternalTransferReport } from "./InternalTransferReport";

const components = {
    statement: StatementReport,
    internalTransfer: InternalTransferReport
}

const PdfReportModal = ({ data, pdfModel, printShow, setPrintShow, sender }) => {
    const componentRef = React.useRef();
    const handlePrint = useReactToPrint({
        bodyClass: "print-statement",
        copyStyles: true,
        documentTitle: new Date().getTime() + "_" + (data?.user?.name || data?.company?.fantasyName),
        onAfterPrint: () => {
            setPrintShow(false)
        },
        content: () => componentRef.current,
    });
    const SelectedComponent = components[pdfModel] || null;

    return (
        < SelectedComponent handlePrint={handlePrint} printShow={printShow} setPrintShow={setPrintShow} data={data} componentRef={componentRef} sender={sender}>
        </SelectedComponent >
    );
}

export { PdfReportModal }